//Generated File 
export const Disabled = `Disabled`;
export const InVisible = `InVisible`;
export const Normal = `Normal`;
export const NotDefined = `NotDefined`;
